"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = function (_a) {
  var sizeBorderWidth = _a.sizeBorderWidth,
      colorDivider = _a.colorDivider,
      colorBg = _a.colorBg;
  return {
    tabs: {
      borderBottom: sizeBorderWidth + "px solid " + colorDivider.normal,
      width: '100%',
      overflow: 'hidden',
      background: colorBg.normal
    },
    flexContainer: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    body: {
      whiteSpace: 'nowrap'
    },
    transition: {
      transition: 'transform 200ms cubic-bezier(0.3, 0.3, 0.5, 0.1)'
    }
  };
};